import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import MasterTemplateDownloadModalUI from './MasterTemplateDownloadModalUI.js'

class MasterTemplateDownloadModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      selectedLoanSpecificTerm: 'nbfc',
      selectedGuaranteeTerm: 'pledge',
      selectedEscrowTerm: 'true',
      selectedSpecialTerm: 'false'
    }
  }

  render() {
    return (
      <MasterTemplateDownloadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        //
        selectedLoanSpecificTerm={this.state.selectedLoanSpecificTerm}
        onSelectLoanSpecificTerm={(event) => { this.setState({ selectedLoanSpecificTerm: event.target.value }) }}
        //
        selectedGuaranteeTerm={this.state.selectedGuaranteeTerm}
        onSelectGuaranteeTerm={(event) => { this.setState({ selectedGuaranteeTerm: event.target.value }) }}
        //
        selectedEscrowTerm={this.state.selectedEscrowTerm}
        onSelectEscrowTerm={(event) => { this.setState({ selectedEscrowTerm: event.target.value }) }}
        //
        selectedSpecialTerm={this.state.selectedSpecialTerm}
        onSelectSpecialTerm={(event) => { this.setState({ selectedSpecialTerm: event.target.value }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.get(context,
      `/api/su/master/templates/fileDownloadSignedUrl`,
      this.onSubmitCallback, null,
      {
        loanSpecificTerm: this.state.selectedLoanSpecificTerm,
        guaranteeTerm: this.state.selectedGuaranteeTerm,
        escrowTerm: this.state.selectedEscrowTerm,
        specialTerm: this.state.selectedSpecialTerm,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default MasterTemplateDownloadModalSF